import { useMemo } from 'react';

import { DateTimeUtils } from '../utils';

import { DateTimePickerFieldProps } from './types';

type Props = Required<Pick<DateTimePickerFieldProps, 'value'>>;
type Return = {
  dateString: string;
  timeString: string;
};

export const useDateTimePickerFieldValues = ({ value }: Props): Return => {
  return useMemo(() => {
    return {
      dateString: DateTimeUtils.toDate(value),
      timeString: DateTimeUtils.toTime(value),
    };
  }, [value]);
};
